import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import * as m from '@/paraglide/messages.js';
import { JobOfferDetailContent } from '@/routes/{-$locale}/job-offers/-components/JobOfferDetailContent';
import { getProfColors } from '@/utils/professionColors';

import { jobOffersApi } from './-components/jobOffersApi';
import { useDeferredValue } from 'react';
import { useLoading } from '@/components/layout/loading/useLoading';

export const Route = createFileRoute('/{-$locale}/job-offers/$id')({
  component: JobOfferDetailPage,
  // loader: async ({ context, params }) => {
  //   await context.queryClient.ensureQueryData(jobOffersApi.detail.queryOptions(params.id));
  // },
  pendingComponent: () => <LoadingSpinner message={m.loading_offer()} />,
});

function JobOfferDetailPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const deferredJobOfferId = useDeferredValue(id);
  const { data: offer } = jobOffersApi.useDetail(deferredJobOfferId);
  useLoading(deferredJobOfferId !== id);

  const colors = getProfColors(offer?.profession);

  return (
    <div style={{ backgroundColor: colors.content, minHeight: 'calc(100dvh - 112px)' }}>
      <div className="mx-auto max-w-screen-xl px-4 py-4">
        <div className="mb-4 lg:hidden">
          <Button
            onClick={() => navigate({ to: '/{-$locale}/job-offers' })}
            startIcon={<ArrowBackIcon />}
            sx={{ color: colors.main }}
          >
            {m.back_to_offers()}
          </Button>
        </div>

        <div className="max-w-2xl">
          <JobOfferDetailContent offer={offer} />
        </div>
      </div>
    </div>
  );
}
